export const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    color: '#354052',
    lineHeight: '24px',

    '& > div': {
      marginRight: 8, //margin for svg TODO refactor this
    },
    '& svg': {
      verticalAlign: 'initial', // centering svg
    },
  },
})
